export const CREATE_EVENT = 'CREATE_EVENT'
export const UPDATE_EVENTDETAILS = 'UPDATE_EVENTDETAILS'
export const CREATE_TRACK = 'CREATE_TRACK'
export const BLOCK_CHAT_USER = 'BLOCK_CHAT_USER'
export const UNBLOCK_CHAT_USER = 'UNBLOCK_CHAT_USER'
export const SET_UPDATE_EVENTDETAILS_SUCCESS = 'SET_UPDATE_EVENTDETAILS_SUCCESS'
export const SET_UPDATE_EVENTDETAILS_ERROR = 'SET_UPDATE_EVENTDETAILS_ERROR'
export const SET_UPDATE_EVENTDETAILS_PROCESSING = 'SET_UPDATE_EVENTDETAILS_PROCESSING'
export const CLEAR_UPDATE_EVENTDETAILS_ERROR = 'CLEAR_UPDATE_EVENTDETAILS_ERROR'
export const UPDATE_EVENT_TRACK = 'UPDATE_EVENT_TRACK'
export const SET_UPDATE_EVENT_TRACK_SUCCESS = 'SET_UPDATE_EVENT_TRACK_SUCCESS'
export const SET_UPDATE_EVENT_TRACK_ERROR = 'SET_UPDATE_EVENT_TRACK_ERROR'
export const SET_UPDATE_EVENT_TRACK_PROCESSING = 'SET_UPDATE_EVENT_TRACK_PROCESSING'
export const SET_CREATE_EVENT_SUCCESS = 'SET_CREATE_EVENT_SUCCESS'
export const SET_CREATE_EVENT_ERROR = 'SET_CREATE_EVENT_ERROR'
export const SET_CREATE_EVENT_PROCESSING = 'SET_CREATE_EVENT_PROCESSING'
export const SET_CREATE_EVENT_TRACK_SUCCESS = 'SET_CREATE_EVENT_TRACK_SUCCESS'
export const SET_CREATE_EVENT_TRACK_ERROR = 'SET_CREATE_EVENT_TRACK_ERROR'
export const SET_CREATE_EVENT_TRACK_PROCESSING = 'SET_CREATE_EVENT_TRACK_PROCESSING'
export const GET_SPEAKERLIST_DATA = 'GET_SPEAKERLIST_DATA'
export const SET_SPEAKERLIST_DATA = 'SET_SPEAKERLIST_DATA'
export const SET_SPEAKERLIST_ERROR = 'SET_SPEAKERLIST_ERROR'
export const SET_SPEAKERLIST_PROCESSING = 'SET_SPEAKERLIST_PROCESSING'
export const GET_EVENTLIST_DATA = 'GET_EVENTLIST_DATA'
export const SET_EVENTLIST_DATA = 'SET_EVENTLIST_DATA'
export const SET_EVENTLIST_ERROR = 'SET_EVENTLIST_ERROR'
export const SET_EVENTLIST_PROCESSING = 'SET_EVENTLIST_PROCESSING'
export const GET_EVENTDETAILS_DATA = 'GET_EVENTDETAILS_DATA'
export const SET_EVENTDETAILS_DATA = 'SET_EVENTDETAILS_DATA'
export const SET_EVENTDETAILS_ERROR = 'SET_EVENTDETAILS_ERROR'
export const SET_EVENTDETAILS_PROCESSING = 'SET_EVENTDETAILS_PROCESSING'
export const GET_EVENT_TRACKS_DATA = 'GET_EVENT_TRACKS_DATA'
export const SET_EVENT_TRACKS_DATA = 'SET_EVENT_TRACKS_DATA'
export const SET_EVENT_TRACKS_ERROR = 'SET_EVENT_TRACKS_ERROR'
export const SET_EVENT_TRACKS_PROCESSING = 'SET_EVENT_TRACKS_PROCESSING'
export const GET_EVENT_TRANSLATION_DATA = 'GET_EVENT_TRANSLATION_DATA'
export const SET_EVENT_TRANSLATION_DATA = 'SET_EVENT_TRANSLATION_DATA'
export const SET_EVENT_TRANSLATION_ERROR = 'SET_EVENT_TRANSLATION_ERROR'
export const SET_EVENT_TRANSLATION_PROCESSING = 'SET_EVENT_TRANSLATION_PROCESSING'
export const UPDATE_EVENT_TRANSLATION = 'UPDATE_EVENT_TRANSLATION'
export const SET_UPDATE_EVENT_TRANSLATION_SUCCESS = 'SET_UPDATE_EVENT_TRANSLATION_SUCCESS'
export const SET_UPDATE_EVENT_TRANSLATION_ERROR = 'SET_UPDATE_EVENT_TRANSLATION_ERROR'
export const SET_UPDATE_EVENT_TRANSLATION_PROCESSING = 'SET_UPDATE_EVENT_TRANSLATION_PROCESSING'
export const DELETE_EVENT_TRANSLATION = 'DELETE_EVENT_TRANSLATION'
export const SET_DELETE_EVENT_TRANSLATION_SUCCESS = 'SET_DELETE_EVENT_TRANSLATION_SUCCESS'
export const SET_DELETE_EVENT_TRANSLATION_ERROR = 'SET_DELETE_EVENT_TRANSLATION_ERROR'
export const SET_DELETE_EVENT_TRANSLATION_PROCESSING = 'SET_DELETE_EVENT_TRANSLATION_PROCESSING'
export const DELETE_SPOTLIGHT_TRANSLATION = 'DELETE_SPOTLIGHT_TRANSLATION'
export const SET_DELETE_SPOTLIGHT_TRANSLATION_SUCCESS = 'SET_DELETE_SPOTLIGHT_TRANSLATION_SUCCESS'
export const SET_DELETE_SPOTLIGHT_TRANSLATION_ERROR = 'SET_DELETE_SPOTLIGHT_TRANSLATION_ERROR'
export const SET_DELETE_SPOTLIGHT_TRANSLATION_PROCESSING =
  'SET_DELETE_SPOTLIGHT_TRANSLATION_PROCESSING'
export const GET_TRACK_DATA = 'GET_TRACK_DATA'
export const SET_TRACK_DATA = 'SET_TRACK_DATA'
export const SET_TRACK_DATA_ERROR = 'SET_TRACK_DATA_ERROR'
export const SET_TRACK_DATA_PROCESSING = 'SET_TRACK_DATA_PROCESSING'
export const GET_CHAT_BLOCKED_USERS_LIST = 'GET_CHAT_BLOCKED_USERS_LIST'
export const SET_CHAT_BLOCKED_USERS_LIST_PROCESSING = 'SET_CHAT_BLOCKED_USERS_LIST_PROCESSING'
export const SET_CHAT_BLOCKED_USERS_LIST = 'SET_CHAT_BLOCKED_USERS_LIST'
export const SET_CHAT_BLOCKED_USERS_LIST_ERROR = 'SET_CHAT_BLOCKED_USERS_LIST_ERROR'
export const GET_EVENT_SCHEDULE_DATA = 'GET_EVENT_SCHEDULE_DATA'
export const SET_EVENT_SCHEDULE_DATA = 'SET_EVENT_SCHEDULE_DATA'
export const SET_EVENT_SCHEDULE_DATA_ERROR = 'SET_EVENT_SCHEDULE_DATA_ERROR'
export const SET_EVENT_SCHEDULE_DATA_PROCESSING = 'SET_EVENT_SCHEDULE_DATA_PROCESSING'
export const CREATE_SESSION = 'CREATE_SESSION'
export const SET_CREATE_SESSION_SUCCESS = 'SET_CREATE_SESSION_SUCCESS'
export const SET_CREATE_SESSION_ERROR = 'SET_CREATE_SESSION_ERROR'
export const SET_CREATE_SESSION_PROCESSING = 'SET_CREATE_SESSION_PROCESSING'
export const CREATE_LA_SPOTLIGHT = 'CREATE_LA_SPOTLIGHT'
export const GET_OR_CREATE_LA_SPOTLIGHT_DATA = 'GET_OR_CREATE_LA_SPOTLIGHT_DATA'
export const UPDATE_LA_SPOTLIGHT = 'UPDATE_LA_SPOTLIGHT'
export const SET_UPDATE_LA_SPOTLIGHT_SUCCESS = 'SET_UPDATE_LA_SPOTLIGHT_SUCCESS'
export const SET_UPDATE_LA_SPOTLIGHT_ERROR = 'SET_UPDATE_LA_SPOTLIGHT_ERROR'
export const SET_UPDATE_LA_SPOTLIGHT_PROCESSING = 'SET_UPDATE_LA_SPOTLIGHT_PROCESSING'
export const GET_LA_SPOTLIGHT_DATA = 'GET_LA_SPOTLIGHT_DATA'
export const SET_LA_SPOTLIGHT_PROCESSING = 'SET_LA_SPOTLIGHT_PROCESSING'
export const SET_LA_SPOTLIGHT_ERROR = 'SET_LA_SPOTLIGHT_ERROR'
export const SET_LA_SPOTLIGHT_DATA = 'SET_LA_SPOTLIGHT_DATA'
export const UPDATE_SESSION = 'UPDATE_SESSION'
export const SET_UPDATE_SESSION_SUCCESS = 'SET_UPDATE_SESSION_SUCCESS'
export const SET_UPDATE_SESSION_ERROR = 'SET_UPDATE_SESSION_ERROR'
export const SET_UPDATE_SESSION_PROCESSING = 'SET_UPDATE_SESSION_PROCESSING'
export const UPDATE_SESSION_TRANSLATION = 'UPDATE_SESSION_TRANSLATION'
export const SET_UPDATE_SESSION_TRANSLATION_SUCCESS = 'SET_UPDATE_SESSION_TRANSLATION_SUCCESS'
export const SET_UPDATE_SESSION_TRANSLATION_ERROR = 'SET_UPDATE_SESSION_TRANSLATION_ERROR'
export const SET_UPDATE_SESSION_TRANSLATION_PROCESSING = 'SET_UPDATE_SESSION_TRANSLATION_PROCESSING'
export const CREATE_SPEAKER = 'CREATE_SPEAKER'
export const SET_CREATE_SPEAKER_SUCCESS = 'SET_CREATE_SPEAKER_SUCCESS'
export const SET_CREATE_SPEAKER_ERROR = 'SET_CREATE_SPEAKER_ERROR'
export const SET_CREATE_SPEAKER_PROCESSING = 'SET_CREATE_SPEAKER_PROCESSING'
export const UPDATE_SPEAKER = 'UPDATE_SPEAKER'
export const SET_UPDATE_SPEAKER_SUCCESS = 'SET_UPDATE_SPEAKER_SUCCESS'
export const SET_UPDATE_SPEAKER_ERROR = 'SET_UPDATE_SPEAKER_ERROR'
export const SET_UPDATE_SPEAKER_PROCESSING = 'SET_UPDATE_SPEAKER_PROCESSING'
export const GET_SPEAKER = 'GET_SPEAKER'
export const SET_SPEAKER_DATA = 'SET_SPEAKER_DATA'
export const SET_SPEAKER_SUCCESS = 'SET_SPEAKER_SUCCESS'
export const SET_SPEAKER_ERROR = 'SET_SPEAKER_ERROR'
export const SET_SPEAKER_PROCESSING = 'SET_SPEAKER_PROCESSING'
export const UPDATE_SPEAKER_BIO = 'UPDATE_SPEAKER_BIO'
export const DELETE_SPEAKER_BIO = 'DELETE_SPEAKER_BIO'
export const SET_UPDATE_SPEAKER_BIO_SUCCESS = 'SET_UPDATE_SPEAKER_BIO_SUCCESS'
export const SET_UPDATE_SPEAKER_BIO_ERROR = 'SET_UPDATE_SPEAKER_BIO_ERROR'
export const SET_UPDATE_SPEAKER_BIO_PROCESSING = 'SET_UPDATE_SPEAKER_BIO_PROCESSING'
export const CLEAR_UPDATE_SPEAKER_BIO_ERROR = 'CLEAR_UPDATE_SPEAKER_BIO_ERROR'
export const GET_EVENT_CHAT_INFO = 'GET_EVENT_CHAT_INFO'
export const SET_EVENT_CHAT_INFO_DATA = 'SET_EVENT_CHAT_INFO_DATA'
export const SET_EVENT_CHAT_INFO_DATA_SUCCESS = 'SET_EVENT_CHAT_INFO_DATA_SUCCESS'
export const SET_EVENT_CHAT_INFO_DATA_ERROR = 'SET_EVENT_CHAT_INFO_DATA_ERROR'
export const SET_EVENT_CHAT_INFO_DATA_PROCESSING = 'SET_EVENT_CHAT_INFO_DATA_PROCESSING'
export const GET_MEDIALIVE_CHANNEL_INFO = 'GET_MEDIALIVE_CHANNEL_INFO'
export const SET_MEDIALIVE_CHANNEL_INFO_DATA = 'SET_MEDIALIVE_CHANNEL_INFO_DATA'
export const SET_MEDIALIVE_CHANNEL_INFO_DATA_ERROR = 'SET_MEDIALIVE_CHANNEL_INFO_DATA_ERROR'
export const SET_MEDIALIVE_CHANNEL_INFO_DATA_PROCESSING =
  'SET_MEDIALIVE_CHANNEL_INFO_DATA_PROCESSING'
export const CLEAR_MEDIALIVE_CHANNEL_INFO = 'CLEAR_MEDIALIVE_CHANNEL_INFO'
export const CREATE_EVENT_CHAT = 'CREATE_EVENT_CHAT'
export const SET_CREATE_EVENT_CHAT_SUCCESS = 'SET_CREATE_EVENT_CHAT_SUCCESS'
export const SET_CREATE_EVENT_CHAT_ERROR = 'SET_CREATE_EVENT_CHAT_ERROR'
export const SET_CREATE_EVENT_CHAT_PROCESSING = 'SET_CREATE_EVENT_CHAT_PROCESSING'
export const CLEAR_EVENT_CHAT_INFO = 'CLEAR_EVENT_CHAT_INFO'
export const UPDATE_MEDIALIVE_CHANNEL = 'UPDATE_MEDIALIVE_CHANNEL'
export const SET_UPDATE_MEDIALIVE_CHANNEL_SUCCESS = 'SET_UPDATE_MEDIALIVE_CHANNEL_SUCCESS'
export const SET_UPDATE_MEDIALIVE_CHANNEL_ERROR = 'SET_UPDATE_MEDIALIVE_CHANNEL_ERROR'
export const SET_UPDATE_MEDIALIVE_CHANNEL_PROCESSING = 'SET_UPDATE_MEDIALIVE_CHANNEL_PROCESSING'
export const STREAM_START = 'STREAM_START'
export const SET_STREAM_START_SUCCESS = 'SET_STREAM_START_SUCCESS'
export const SET_STREAM_START_ERROR = 'SET_STREAM_START_ERROR'
export const SET_STREAM_START_PROCESSING = 'SET_STREAM_START_PROCESSING'
export const STREAM_STOP = 'STREAM_STOP'
export const SET_STREAM_STOP_SUCCESS = 'SET_STREAM_STOP_SUCCESS'
export const SET_STREAM_STOP_ERROR = 'SET_STREAM_STOP_ERROR'
export const SET_STREAM_STOP_PROCESSING = 'SET_STREAM_STOP_PROCESSING'
export const CLEAR_MEDIALIVE_METRICS_DATA = 'CLEAR_MEDIALIVE_METRICS_DATA'
export const GET_MEDIALIVE_METRICS = 'GET_MEDIALIVE_METRICS'
export const SET_MEDIALIVE_METRICS = 'SET_MEDIALIVE_METRICS'
export const SET_MEDIALIVE_METRICS_ERROR = 'SET_MEDIALIVE_METRICS_ERROR'
export const SET_MEDIALIVE_METRICS_PROCESSING = 'SET_MEDIALIVE_METRICS_PROCESSING'
export const DELETE_SESSION = 'DELETE_SESSION'
export const DELETE_SESSION_SUCCESS = 'DELETE_SESSION_SUCCESS'
export const DELETE_SESSION_PROCESSING = 'DELETE_SESSION_PROCESSING'
export const DELETE_SESSION_ERROR = 'DELETE_SESSION_ERROR'
export const DELETE_EVENT = 'DELETE_EVENT'
export const DELETE_EVENT_SUCCESS = 'DELETE_EVENT_SUCCESS'
export const DELETE_EVENT_PROCESSING = 'DELETE_EVENT_PROCESSING'
export const DELETE_EVENT_ERROR = 'DELETE_EVENT_ERROR'
export const GET_USER_EMAIL = 'GET_USER_EMAIL'
export const SET_USER_EMAIL = 'SET_USER_EMAIL'
export const SET_USER_EMAIL_ERROR = 'SET_USER_EMAIL_ERROR'
export const SET_USER_EMAIL_PROCESSING = 'SET_USER_EMAIL_PROCESSING'
export const GET_UIDS_FROM_YOUBORA = 'GET_UIDS_FROM_YOUBORA'
export const SET_UIDS_FROM_YOUBORA = 'SET_UIDS_FROM_YOUBORA'
export const GET_UIDS_FROM_YOUBORA_ERROR = 'GET_UIDS_FROM_YOUBORA_ERROR'
export const GET_UIDS_FROM_YOUBORA_PROCESSING = 'GET_UIDS_FROM_YOUBORA_PROCESSING'
export const CLEAR_UIDS_FROM_YOUBORA = 'CLEAR_UIDS_FROM_YOUBORA'

export function createEventDetails ({
  startDate,
  endDate,
  primaryLanguage,
  title,
  route,
  featured,
  summaryEnabled = false,
  webviewUrl,
  type,
}) {
  return {
    type: CREATE_EVENT,
    payload: {
      startDate,
      endDate,
      primaryLanguage,
      title,
      route,
      featured,
      summaryEnabled,
      webviewUrl,
      type,
    },
  }
}

export function setCreateEventSuccess ({ eventData }) {
  return {
    type: SET_CREATE_EVENT_SUCCESS,
    payload: { eventData },
  }
}

export function setCreateEventError ({ error }) {
  return {
    type: SET_CREATE_EVENT_ERROR,
    payload: { error },
  }
}

export function setCreateEventProcessing ({ processing = true }) {
  return {
    type: SET_CREATE_EVENT_PROCESSING,
    payload: { processing },
  }
}

export function createEventTrack ({ eventId, title, description, playbackUrlOverride, language }) {
  return {
    type: CREATE_TRACK,
    payload: {
      eventId,
      title,
      description,
      playbackUrlOverride,
      language,
    },
  }
}

export function setCreateEventTrackSuccess () {
  return {
    type: SET_CREATE_EVENT_TRACK_SUCCESS,
    payload: {},
  }
}

export function setCreateEventTrackError ({ error }) {
  return {
    type: SET_CREATE_EVENT_TRACK_ERROR,
    payload: { error },
  }
}

export function setCreateEventTrackProcessing ({ processing = true }) {
  return {
    type: SET_CREATE_EVENT_TRACK_PROCESSING,
    payload: { processing },
  }
}

export function blockChatUser ({ channel, username }) {
  return {
    type: BLOCK_CHAT_USER,
    payload: { channel, username },
  }
}

export function unBlockChatUser ({ channel, username }) {
  return {
    type: UNBLOCK_CHAT_USER,
    payload: { channel, username },
  }
}

export function updateEventDetails ({ eventId, language, body }) {
  return {
    type: UPDATE_EVENTDETAILS,
    payload: { eventId, language, body },
  }
}

export function setUpdateEventDetailsSuccess ({ eventId }) {
  return {
    type: SET_UPDATE_EVENTDETAILS_SUCCESS,
    payload: { eventId },
  }
}

export function setUpdateEventDetailsError ({ eventId, error }) {
  return {
    type: SET_UPDATE_EVENTDETAILS_ERROR,
    payload: { eventId, error },
  }
}

export function setUpdateEventDetailsProcessing ({ eventId, processing = true }) {
  return {
    type: SET_UPDATE_EVENTDETAILS_PROCESSING,
    payload: { eventId, processing },
  }
}

export function clearUpdateEventDetailsError ({ eventId }) {
  return {
    type: CLEAR_UPDATE_EVENTDETAILS_ERROR,
    payload: { eventId },
  }
}

export function updateEventTrack ({ trackId, language, body }) {
  return {
    type: UPDATE_EVENT_TRACK,
    payload: { trackId, language, body },
  }
}

export function setUpdateEventTrackSuccess ({ trackId }) {
  return {
    type: SET_UPDATE_EVENT_TRACK_SUCCESS,
    payload: { trackId },
  }
}

export function setUpdateEventTrackError ({ trackId, error }) {
  return {
    type: SET_UPDATE_EVENT_TRACK_ERROR,
    payload: { trackId, error },
  }
}

export function setUpdateEventTrackProcessing ({ trackId, processing = true }) {
  return {
    type: SET_UPDATE_EVENT_TRACK_PROCESSING,
    payload: { trackId, processing },
  }
}

export function getSpeakerListData () {
  return {
    type: GET_SPEAKERLIST_DATA,
  }
}

export function setSpeakerListData ({ data }) {
  return {
    type: SET_SPEAKERLIST_DATA,
    payload: { data },
  }
}

export function setSpeakerListError ({ error }) {
  return {
    type: SET_SPEAKERLIST_ERROR,
    payload: { error },
  }
}

export function setSpeakerListProcessing ({ processing = true }) {
  return {
    type: SET_SPEAKERLIST_PROCESSING,
    payload: { processing },
  }
}

export function getEventListData () {
  return {
    type: GET_EVENTLIST_DATA,
  }
}

export function setEventListData ({ data }) {
  return {
    type: SET_EVENTLIST_DATA,
    payload: { data },
  }
}

export function setEventListError ({ error }) {
  return {
    type: SET_EVENTLIST_ERROR,
    payload: { error },
  }
}

export function setEventListProcessing ({ processing = true }) {
  return {
    type: SET_EVENTLIST_PROCESSING,
    payload: { processing },
  }
}

export function getEventDetailsData ({ eventId, language }) {
  return {
    type: GET_EVENTDETAILS_DATA,
    payload: { eventId, language },
  }
}

export function setEventDetailsData ({ data }) {
  return {
    type: SET_EVENTDETAILS_DATA,
    payload: { data },
  }
}

export function setEventDetailsError ({ error }) {
  return {
    type: SET_EVENTDETAILS_ERROR,
    payload: { error },
  }
}

export function setEventDetailsProcessing ({ processing = true }) {
  return {
    type: SET_EVENTDETAILS_PROCESSING,
    payload: { processing },
  }
}

export function getEventTracksData ({ eventId, language }) {
  return {
    type: GET_EVENT_TRACKS_DATA,
    payload: { eventId, language },
  }
}

export function setEventTracksData ({ data }) {
  return {
    type: SET_EVENT_TRACKS_DATA,
    payload: { data },
  }
}

export function setEventTracksError ({ error }) {
  return {
    type: SET_EVENT_TRACKS_ERROR,
    payload: { error },
  }
}

export function setEventTracksProcessing ({ processing = true }) {
  return {
    type: SET_EVENT_TRACKS_PROCESSING,
    payload: { processing },
  }
}

export function getEventTranslationData ({ eventId, language }) {
  return {
    type: GET_EVENT_TRANSLATION_DATA,
    payload: { eventId, language },
  }
}

export function setEventTranslationData ({ data }) {
  return {
    type: SET_EVENT_TRANSLATION_DATA,
    payload: { data },
  }
}

export function setEventTranslationError ({ error }) {
  return {
    type: SET_EVENT_TRANSLATION_ERROR,
    payload: { error },
  }
}

export function setEventTranslationProcessing ({ processing = true }) {
  return {
    type: SET_EVENT_TRANSLATION_PROCESSING,
    payload: { processing },
  }
}

export function updateEventTranslationData ({ eventId, language, body }) {
  return {
    type: UPDATE_EVENT_TRANSLATION,
    payload: { eventId, language, body },
  }
}

export function setUpdateEventTranslationSuccess ({ eventId }) {
  return {
    type: SET_UPDATE_EVENT_TRANSLATION_SUCCESS,
    payload: { eventId },
  }
}

export function setUpdateEventTranslationError ({ eventId, error }) {
  return {
    type: SET_UPDATE_EVENT_TRANSLATION_ERROR,
    payload: { eventId, error },
  }
}

export function setUpdateEventTranslationProcessing ({ eventId, processing = true }) {
  return {
    type: SET_UPDATE_EVENT_TRANSLATION_PROCESSING,
    payload: { eventId, processing },
  }
}

export function deleteEventTranslationData ({ eventId, language }) {
  return {
    type: DELETE_EVENT_TRANSLATION,
    payload: { eventId, language },
  }
}

export function setDeleteEventTranslationSuccess ({ eventId, language }) {
  return {
    type: SET_DELETE_EVENT_TRANSLATION_SUCCESS,
    payload: { eventId, language },
  }
}

export function setDeleteEventTranslationError ({ eventId, language, error }) {
  return {
    type: SET_DELETE_EVENT_TRANSLATION_ERROR,
    payload: { eventId, language, error },
  }
}

export function setDeleteEventTranslationProcessing ({ eventId, language, processing = true }) {
  return {
    type: SET_DELETE_EVENT_TRANSLATION_PROCESSING,
    payload: { eventId, language, processing },
  }
}

export function deleteSpotlightTranslationData ({ eventId, spotLightId, language }) {
  return {
    type: DELETE_SPOTLIGHT_TRANSLATION,
    payload: { eventId, spotLightId, language },
  }
}

export function setDeleteSpotlightTranslationSuccess ({ eventId, spotLightId, language }) {
  return {
    type: SET_DELETE_SPOTLIGHT_TRANSLATION_SUCCESS,
    payload: { eventId, spotLightId, language },
  }
}

export function setDeleteSpotlightTranslationError ({ eventId, spotLightId, language, error }) {
  return {
    type: SET_DELETE_SPOTLIGHT_TRANSLATION_ERROR,
    payload: { eventId, spotLightId, language, error },
  }
}

export function setDeleteSpotlightTranslationProcessing ({
  eventId,
  spotLightId,
  language,
  processing = true,
}) {
  return {
    type: SET_DELETE_SPOTLIGHT_TRANSLATION_PROCESSING,
    payload: { eventId, spotLightId, language, processing },
  }
}

export function getTrackData ({ trackId, language = 'en' }) {
  return {
    type: GET_TRACK_DATA,
    payload: { trackId, language },
  }
}

export function setTrackDataProcessing ({ trackId, processing = true }) {
  return {
    type: SET_TRACK_DATA_PROCESSING,
    payload: { trackId, processing },
  }
}

export function setTrackData ({ data }) {
  return {
    type: SET_TRACK_DATA,
    payload: { data },
  }
}

export function setTrackDataError ({ error }) {
  return {
    type: SET_TRACK_DATA_ERROR,
    payload: { error },
  }
}

export function getChatBlockedUsers ({ channel }) {
  return {
    type: GET_CHAT_BLOCKED_USERS_LIST,
    payload: { channel },
  }
}

export function setChatBlockedUsersListProcessing ({ channel, processing = true }) {
  return {
    type: SET_CHAT_BLOCKED_USERS_LIST_PROCESSING,
    payload: { channel, processing },
  }
}

export function setChatBlockedUsersList ({ data, channel }) {
  return {
    type: SET_CHAT_BLOCKED_USERS_LIST,
    payload: { data, channel },
  }
}

export function setChatBlockedUsersListError ({ error }) {
  return {
    type: SET_CHAT_BLOCKED_USERS_LIST_ERROR,
    payload: { error },
  }
}

export function getEventScheduleData ({ trackId, language }) {
  return {
    type: GET_EVENT_SCHEDULE_DATA,
    payload: { trackId, language },
  }
}

export function setEventScheduleData ({ data }) {
  return {
    type: SET_EVENT_SCHEDULE_DATA,
    payload: { data },
  }
}

export function setEventScheduleDataError ({ error }) {
  return {
    type: SET_EVENT_SCHEDULE_DATA_ERROR,
    payload: { error },
  }
}

export function setEventScheduleDataProcessing ({ processing = true }) {
  return {
    type: SET_EVENT_SCHEDULE_DATA_PROCESSING,
    payload: { processing },
  }
}

export function createSession ({
  eventId,
  trackId,
  isFree,
  allowAnon,
  title,
  startDate,
  endDate,
  language,
  isLiveStream,
}) {
  return {
    type: CREATE_SESSION,
    payload: {
      eventId,
      trackId,
      isFree,
      allowAnon,
      title,
      startDate,
      endDate,
      language,
      isLiveStream,
    },
  }
}

export function setCreateSessionSuccess () {
  return {
    type: SET_CREATE_SESSION_SUCCESS,
    payload: {},
  }
}

export function setCreateSessionError ({ error }) {
  return {
    type: SET_CREATE_SESSION_ERROR,
    payload: { error },
  }
}

export function setCreateSessionProcessing ({ processing = true }) {
  return {
    type: SET_CREATE_SESSION_PROCESSING,
    payload: { processing },
  }
}

export function createLASpotLight ({ payload, language }) {
  return {
    type: CREATE_LA_SPOTLIGHT,
    payload: { body: payload, language },
  }
}

export function updateLASpotLight ({ spotLightId, language, body }) {
  return {
    type: UPDATE_LA_SPOTLIGHT,
    payload: { spotLightId, language, body },
  }
}

export function setUpdateLASpotlightSuccess ({ spotLightId }) {
  return {
    type: SET_UPDATE_LA_SPOTLIGHT_SUCCESS,
    payload: { spotLightId },
  }
}

export function setUpdateLASpotlightError ({ language, error }) {
  return {
    type: SET_UPDATE_LA_SPOTLIGHT_ERROR,
    payload: { language, error },
  }
}

export function setUpdateLASpotlightProcessing ({ processing = true }) {
  return {
    type: SET_UPDATE_LA_SPOTLIGHT_PROCESSING,
    payload: { processing },
  }
}

export function getLASpotlightData ({ eventId, language }) {
  return {
    type: GET_LA_SPOTLIGHT_DATA,
    payload: { eventId, language },
  }
}

export function getOrCreateLASpotlightData ({ eventId, language }) {
  return {
    type: GET_OR_CREATE_LA_SPOTLIGHT_DATA,
    payload: { eventId, language },
  }
}

export function setLASpotlightError ({ language, error }) {
  return {
    type: SET_LA_SPOTLIGHT_ERROR,
    payload: { language, error },
  }
}

export function setLASpotlightProcessing ({ processing = true }) {
  return {
    type: SET_LA_SPOTLIGHT_PROCESSING,
    payload: { processing },
  }
}
export function setLASpotlightData ({ language, data }) {
  return {
    type: SET_LA_SPOTLIGHT_DATA,
    payload: { [language]: data },
  }
}
export function updateSession ({ sessionId, language, body }) {
  return {
    type: UPDATE_SESSION,
    payload: { sessionId, language, body },
  }
}

export function setUpdateSessionSuccess ({ sessionId }) {
  return {
    type: SET_UPDATE_SESSION_SUCCESS,
    payload: { sessionId },
  }
}

export function setUpdateSessionError ({ sessionId, error }) {
  return {
    type: SET_UPDATE_SESSION_ERROR,
    payload: { sessionId, error },
  }
}

export function setUpdateSessionProcessing ({ sessionId, processing = true }) {
  return {
    type: SET_UPDATE_SESSION_PROCESSING,
    payload: { sessionId, processing },
  }
}

export function updateSessionTranslation ({ sessionId, language, body }) {
  return {
    type: UPDATE_SESSION_TRANSLATION,
    payload: { sessionId, language, body },
  }
}

export function setUpdateSessionTranslationSuccess ({ sessionId }) {
  return {
    type: SET_UPDATE_SESSION_TRANSLATION_SUCCESS,
    payload: { sessionId },
  }
}

export function setUpdateSessionTranslationError ({ sessionId, error }) {
  return {
    type: SET_UPDATE_SESSION_TRANSLATION_ERROR,
    payload: { sessionId, error },
  }
}

export function setUpdateSessionTranslationProcessing ({ sessionId, processing = true }) {
  return {
    type: SET_UPDATE_SESSION_TRANSLATION_PROCESSING,
    payload: { sessionId, processing },
  }
}

export function createSpeaker ({
  firstName,
  middleName,
  lastName,
  honorific,
  bio,
  headshot,
  url,
  language,
}) {
  return {
    type: CREATE_SPEAKER,
    payload: {
      firstName,
      middleName,
      lastName,
      honorific,
      bio,
      headshot,
      url,
      language,
    },
  }
}

export function setCreateSpeakerSuccess ({ id }) {
  return {
    type: SET_CREATE_SPEAKER_SUCCESS,
    payload: { speakerId: id },
  }
}

export function setCreateSpeakerError ({ speakerId, error }) {
  return {
    type: SET_CREATE_SPEAKER_ERROR,
    payload: { speakerId, error },
  }
}

export function setCreateSpeakerProcessing ({ processing = true }) {
  return {
    type: SET_CREATE_SPEAKER_PROCESSING,
    payload: { processing },
  }
}
export function updateSpeaker (speakerId, body) {
  return {
    type: UPDATE_SPEAKER,
    payload: { speakerId, body },
  }
}

export function setUpdateSpeakerSuccess ({ speakerId }) {
  return {
    type: SET_UPDATE_SPEAKER_SUCCESS,
    payload: { speakerId },
  }
}

export function setUpdateSpeakerError ({ speakerId, error }) {
  return {
    type: SET_UPDATE_SPEAKER_ERROR,
    payload: { speakerId, error },
  }
}

export function setUpdateSpeakerProcessing ({ processing = true }) {
  return {
    type: SET_UPDATE_SPEAKER_PROCESSING,
    payload: { processing },
  }
}

export function getSpeaker (speakerId, language) {
  return {
    type: GET_SPEAKER,
    payload: { speakerId, language },
  }
}

export function setSpeakerData ({ data }) {
  return {
    type: SET_SPEAKER_DATA,
    payload: { data },
  }
}

export function setSpeakerSuccess ({ speakerId }) {
  return {
    type: SET_SPEAKER_SUCCESS,
    payload: { speakerId },
  }
}

export function setSpeakerError ({ speakerId, error }) {
  return {
    type: SET_SPEAKER_ERROR,
    payload: { speakerId, error },
  }
}

export function setSpeakerProcessing ({ processing = true }) {
  return {
    type: SET_SPEAKER_PROCESSING,
    payload: { processing },
  }
}

export function updateSpeakerBio (speakerId, language, body) {
  return {
    type: UPDATE_SPEAKER_BIO,
    payload: { speakerId, language, body },
  }
}

export function deleteSpeakerBio (speakerId, language) {
  return {
    type: DELETE_SPEAKER_BIO,
    payload: { speakerId, language },
  }
}

export function setUpdateSpeakerBioSuccess ({ speakerId }) {
  return {
    type: SET_UPDATE_SPEAKER_BIO_SUCCESS,
    payload: { speakerId },
  }
}

export function setUpdateSpeakerBioError ({ speakerId, error }) {
  return {
    type: SET_UPDATE_SPEAKER_BIO_ERROR,
    payload: { speakerId, error },
  }
}

export function setUpdateSpeakerBioProcessing ({ processing = true }) {
  return {
    type: SET_UPDATE_SPEAKER_BIO_PROCESSING,
    payload: { processing },
  }
}

export function clearUpdateSpeakerBioError () {
  return {
    type: CLEAR_UPDATE_SPEAKER_BIO_ERROR,
  }
}

export function clearChatInfo () {
  return {
    type: CLEAR_EVENT_CHAT_INFO,
  }
}
export function getEventChatInfo ({ eventId }) {
  return {
    type: GET_EVENT_CHAT_INFO,
    payload: { eventId },
  }
}
export function setEventChatInfoData ({ data }) {
  return {
    type: SET_EVENT_CHAT_INFO_DATA,
    payload: { data },
  }
}
export function setEventChatInfoDataError ({ error }) {
  return {
    type: SET_EVENT_CHAT_INFO_DATA_ERROR,
    payload: { error },
  }
}
export function setEventChatInfoDataProcessing ({ processing = true }) {
  return {
    type: SET_EVENT_CHAT_INFO_DATA_PROCESSING,
    payload: { processing },
  }
}
export function setEventChatInfoDataSuccess ({ data }) {
  return {
    type: SET_EVENT_CHAT_INFO_DATA_SUCCESS,
    payload: { data },
  }
}
export function getMediaLiveChannelInfo ({ url, id, channelId }) {
  return {
    type: GET_MEDIALIVE_CHANNEL_INFO,
    payload: { url, id, channelId },
  }
}
export function setMediaLiveChannelInfoData ({ data, channelId }) {
  return {
    type: SET_MEDIALIVE_CHANNEL_INFO_DATA,
    payload: { data, channelId },
  }
}
export function setMediaLiveChannelInfoError ({ error, channelId }) {
  return {
    type: SET_MEDIALIVE_CHANNEL_INFO_DATA_ERROR,
    payload: { error, channelId },
  }
}
export function setMediaLiveChannelInfoProcessing ({ processing = true, channelId }) {
  return {
    type: SET_MEDIALIVE_CHANNEL_INFO_DATA_PROCESSING,
    payload: { processing, channelId },
  }
}

export function clearMediaLiveChannelInfo () {
  return {
    type: CLEAR_MEDIALIVE_CHANNEL_INFO,
  }
}

export function createEventChat ({ eventId, sendbirdChannelId, sendbirdAppId }) {
  return {
    type: CREATE_EVENT_CHAT,
    payload: { eventId, sendbirdChannelId, sendbirdAppId },
  }
}
export function setCreateEventChatSuccess () {
  return {
    type: SET_CREATE_EVENT_CHAT_SUCCESS,
    payload: {},
  }
}
export function setCreateEventChatError ({ error }) {
  return {
    type: SET_CREATE_EVENT_CHAT_ERROR,
    payload: { error },
  }
}
export function setCreateEventChatProcessing ({ processing = true }) {
  return {
    type: SET_CREATE_EVENT_CHAT_PROCESSING,
    payload: { processing },
  }
}
export function updateMediaLiveChannel ({ url, id, body }) {
  return {
    type: UPDATE_MEDIALIVE_CHANNEL,
    payload: { url, id, body },
  }
}
export function setUpdateMediaLiveChannelSuccess ({ id }) {
  return {
    type: SET_UPDATE_MEDIALIVE_CHANNEL_SUCCESS,
    payload: { id },
  }
}
export function setUpdateMediaLiveChannelError ({ id, error }) {
  return {
    type: SET_UPDATE_MEDIALIVE_CHANNEL_ERROR,
    payload: { id, error },
  }
}
export function setUpdateMediaLiveChannelProcessing ({ id, processing = true }) {
  return {
    type: SET_UPDATE_MEDIALIVE_CHANNEL_PROCESSING,
    payload: { id, processing },
  }
}

export function startStream ({ id, server }) {
  return {
    type: STREAM_START,
    payload: { id, server },
  }
}
export function setStartStreamSuccess ({ id }) {
  return {
    type: SET_STREAM_START_SUCCESS,
    payload: { id },
  }
}
export function setStartStreamError ({ id, error }) {
  return {
    type: SET_STREAM_START_ERROR,
    payload: { id, error },
  }
}
export function setStartStreamProcessing ({ id, processing = true }) {
  return {
    type: SET_STREAM_START_PROCESSING,
    payload: { id, processing },
  }
}

export function stopStream ({ id, server }) {
  return {
    type: STREAM_STOP,
    payload: { id, server },
  }
}
export function setStopStreamSuccess ({ id }) {
  return {
    type: SET_STREAM_STOP_SUCCESS,
    payload: { id },
  }
}
export function setStopStreamError ({ id, error }) {
  return {
    type: SET_STREAM_STOP_ERROR,
    payload: { id, error },
  }
}
export function setStopStreamProcessing ({ id, processing = true }) {
  return {
    type: SET_STREAM_STOP_PROCESSING,
    payload: { id, processing },
  }
}
export function clearMediaLiveMetricsData () {
  return {
    type: CLEAR_MEDIALIVE_METRICS_DATA,
  }
}
export function getMediaLiveMetrics ({
  server,
  id,
  name,
  statistics,
  unit,
  pipeline,
  spanMinutes,
  periodSeconds,
}) {
  return {
    type: GET_MEDIALIVE_METRICS,
    payload: {
      server,
      id,
      name,
      statistics,
      unit,
      pipeline,
      spanMinutes,
      periodSeconds,
    },
  }
}
export function setMediaLiveMetrics ({ data, id, pipeline, name }) {
  return {
    type: SET_MEDIALIVE_METRICS,
    payload: {
      data,
      id,
      pipeline,
      name,
    },
  }
}
export function setMediaLiveMetricsError ({ id, pipeline, error, name }) {
  return {
    type: SET_MEDIALIVE_METRICS_ERROR,
    payload: {
      id,
      pipeline,
      name,
      error,
    },
  }
}
export function setMediaLiveMetricsProcessing ({ id, pipeline, name, processing = true }) {
  return {
    type: SET_MEDIALIVE_METRICS_PROCESSING,
    payload: {
      id,
      pipeline,
      name,
      processing,
    },
  }
}
export function deleteSession (id) {
  return {
    type: DELETE_SESSION,
    payload: { id },
  }
}
export function setDeleteSessionSuccess () {
  return {
    type: DELETE_SESSION_SUCCESS,
  }
}
export function setDeleteSessionError ({ id, error }) {
  return {
    type: DELETE_SESSION_ERROR,
    payload: { id, error },
  }
}
export function setDeleteSessionProcessing ({ id }) {
  return {
    type: DELETE_SESSION_PROCESSING,
    payload: { id },
  }
}
export function deleteEvent (id) {
  return {
    type: DELETE_EVENT,
    payload: { id },
  }
}
export function setDeleteEventSuccess () {
  return {
    type: DELETE_EVENT_SUCCESS,
  }
}
export function setDeleteEventError ({ id, error }) {
  return {
    type: DELETE_EVENT_ERROR,
    payload: { id, error },
  }
}
export function setDeleteEventProcessing ({ id }) {
  return {
    type: DELETE_EVENT_PROCESSING,
    payload: { id },
  }
}

export function getUserEmail ({ uid }) {
  return {
    type: GET_USER_EMAIL,
    payload: { uid },
  }
}

export function setUserEmail ({ uid, data }) {
  return {
    type: SET_USER_EMAIL,
    payload: { uid, data },
  }
}

export function setUserEmailError ({ error }) {
  return {
    type: SET_USER_EMAIL_ERROR,
    payload: { error },
  }
}

export function setUserEmailProcessing ({ processing = true }) {
  return {
    type: SET_USER_EMAIL_PROCESSING,
    payload: { processing },
  }
}

export function getUidsFromYoubora ({ startDate, endDate }) {
  return {
    type: GET_UIDS_FROM_YOUBORA,
    payload: { startDate, endDate },
  }
}

export function setUidsFromYoubora ({ data, requestCurl, requestDates }) {
  return {
    type: SET_UIDS_FROM_YOUBORA,
    payload: { data, requestCurl, requestDates },
  }
}

export function getUidsFromYouboraError ({ error }) {
  return {
    type: GET_UIDS_FROM_YOUBORA_ERROR,
    payload: { error },
  }
}

export function getUidsFromYouboraProcessing ({ processing = true }) {
  return {
    type: GET_UIDS_FROM_YOUBORA_PROCESSING,
    payload: { processing },
  }
}

export function clearUidsFromYoubora () {
  return {
    type: CLEAR_UIDS_FROM_YOUBORA,
  }
}
